import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'next-common-lib';
import TextFieldHookForm from 'components/Common/InputBox/TextFieldHookForm';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';

export const InputButtonRow = ({
  header,
  name,
  isRequired,
  disabled,
  btnLabel,
  btnAction,
  children,
  unUsedInputBox,
  guideText,
}) => {
  return (
    <TblRow>
      <TblRowHeader rowHeader={header} isRequired={isRequired} />
      <TblRowTail
        formClass="form-field-multi"
        unUsedInputBox={unUsedInputBox}
        guideText={guideText}
        buttonChildren={
          <Button
            componentType="solid"
            className="primary ie-btn"
            label={btnLabel}
            disabled={disabled}
            onClick={btnAction}
          />
        }
      >
        <>
          {children}
          <TextFieldHookForm
            name={name}
            className="type-full"
            maxLength={50}
            disabled={disabled}
            useExpLabel={!unUsedInputBox}
          />
        </>
      </TblRowTail>
    </TblRow>
  );
};
InputButtonRow.propTypes = {
  header: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  btnLabel: PropTypes.string.isRequired,
  btnAction: PropTypes.func.isRequired,
  children: PropTypes.node,
  unUsedInputBox: PropTypes.bool,
  guideText: PropTypes.node,
};
InputButtonRow.defaultProps = {
  isRequired: false,
  disabled: false,
  unUsedInputBox: false,
  children: '',
  guideText: <></>,
};
export default InputButtonRow;
